import { CommonModule } from '@angular/common';
import { FIELD_TYPE_COMPONENTS, FORMLY_CONFIG } from './formly-core.config';
import { FormlyDatepickerTypeComponent } from './date.component';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyModule } from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgModule } from '@angular/core';
import { NgxMaskModule } from 'ngx-mask';
import { ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';


@NgModule({
    imports: [
        CommonModule,
        FormlySelectModule,
        MatDatepickerModule,
        MatInputModule,
        MatNativeDateModule,
        TextMaskModule,
        ReactiveFormsModule,
        FormlyModule.forRoot(FORMLY_CONFIG),
        FormlyMaterialModule,
        NgxMaskModule.forRoot(),
        MatTooltipModule,
        MatIconModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatChipsModule,
        MatCheckboxModule,
        MatButtonModule,
        MatSelectModule,
    ],
  declarations: [FormlyDatepickerTypeComponent, FIELD_TYPE_COMPONENTS ],
})
export class FormlyCoreModule {}
